/**
 * Twinkling Sparkles and Discovery Magic Stars.
 */
import { ParticleSystem, Particle } from './ParticleSystem';
import { SVGObjectConfig } from '../objects/SVGObject';

export class SparklesEffect extends ParticleSystem {
  constructor(config: SVGObjectConfig) {
    super(config, 40);
    this.emitRate = 20;
  }

  protected createParticle(): Particle {
    const colors = ['#fbbf24', '#f59e0b', '#38bdf8', '#ffffff'];
    return {
      x: (Math.random() - 0.5) * 140,
      y: (Math.random() - 0.5) * 140,
      vx: (Math.random() - 0.5) * 30,
      vy: (Math.random() - 0.5) * 30,
      size: 2 + Math.random() * 5,
      alpha: 1,
      life: 0,
      maxLife: 0.9,
      color: colors[Math.floor(Math.random() * colors.length)]
    };
  }

  protected updateParticle(p: Particle, delta: number): void {
    p.x += p.vx * delta;
    p.y += p.vy * delta;
    p.alpha = Math.sin((p.life / p.maxLife) * Math.PI);
  }
}
